import { buildOrgUrl } from "@/utils/navigation/orgUrl";

type CustomerRow = { id: string; name: string };
type NavDeps = {
  router: { push: (location: string) => unknown };
  setCustomer?: (payload: CustomerRow) => unknown;
  clearAzureCache?: () => unknown;
  clearLicenceCache?: () => unknown;
};

export const redirectToCustomerDetails = (
  row: CustomerRow,
  {
    router,
    setCustomer,
    clearAzureCache,
    clearLicenceCache,
    isDashboardAvailableCustomer,
  }: NavDeps & { isDashboardAvailableCustomer: boolean },
) => {
  const suffix = isDashboardAvailableCustomer ? "dashboard" : "";

  clearAzureCache?.();
  clearLicenceCache?.();
  setCustomer?.(row);

  return router.push(buildOrgUrl("customer", row.id, suffix));
};
